import React, {memo} from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'
import { Image } from '../Image/Image';

// component
import {Link} from "gatsby";
import Format from '../Format/Format';


// styles
import './news-item.scss';


const NewsItem = (props) => {
  const { t } = useTranslation();
  const {slug, image, title, type, date} = props;
  return (
      <Link to={slug} className="news-item__story">
        <div className="news-item__story-container">
          <div
              className="news-item__story-img-container"
          >
            <Image className="news-item__story-img" fluid={image}/>
          </div>
          <span className="news-item__story-info">
            {t(`filters.${type}`)}
            <span>/</span>
            <Format type="date">{date}</Format>
          </span>
          <h5 className="news-item__story-title">{title}</h5>
        </div>
      </Link>
  );
}

export default memo(NewsItem);

NewsItem.defaultProps = {
  slug: '',
  image: {},
  title: '',
  type: '',
  date: ''
};

NewsItem.propTypes = {
  slug: PropTypes.string,
  image: PropTypes.object,
  title: PropTypes.string,
  type: PropTypes.string,
  date: PropTypes.string
};
